import script from "./SideBarItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideBarItem.vue?vue&type=script&lang=ts&setup=true"

import "./SideBarItem.vue?vue&type=style&index=0&id=7e034a46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e034a46"]])

export default __exports__